import react from "react";
import classNames from "classnames";

const classNameActive =
  "border-gray-300 bg-white hover:bg-gray-50 text-gray-500 duration-300 cursor-pointer";
const classNameDisabled =
  "border-gray-300 opacity-30 text-gray-500 cursor-not-allowed";

const NextPage = ({ canNextPage, ...rest }) => {
  return (
    <button
      {...rest}
      disabled={!canNextPage}
      className={classNames(
        " relative inline-flex items-center px-2 py-2 rounded-r-md border text-sm font-medium",
        {
          [classNameActive]: canNextPage,
          [classNameDisabled]: !canNextPage,
        }
      )}
    >
      <span className="sr-only">Next</span>
      <svg
        className="h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clipRule="evenodd"
        />
      </svg>
    </button>
  );
};

export default NextPage;
